exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bills-overlay{width:100%;position:absolute;top:0;left:0;height:100vh;width:100vw;overflow:hidden;pointer-events:none}.bills-overlay .bill{position:absolute;bottom:0;width:400px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-18f914b6","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/sections/racism/bills-overlay.vue
// module id = 587
// module chunks = 0